import { useLocation } from 'react-router';

const noFormat = (e) => e;

export default (params, format = noFormat) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return params.map((p, i) => format(query.get(p), i));
};
